import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

const MonitoringBar = ({ data, clickMonitoring }: { data: any, clickMonitoring: Function }) => {

  const { t } = useTranslation();

  const barStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    //border: '1px solid #e0e0e0',
    borderRadius: '4px',
    padding: '5px',
    marginBottom: '10px',
    maxWidth: '1730px'
  };

  // Calcula o tamanho de cada quadrado com base no número de quadrados e espaço disponível
  const squareSize = `${(100 - (data.length - 1) * 5) / data.length}%`; // Desconta o espaço entre os quadrados

  const infoContainerStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Distribui os quadrados horizontalmente
    gap: '0px',
    width: '100%', // Garante que os quadrados ocupem toda a largura
  };

  const infoItemStyle: CSSProperties = {
    //width: squareSize, // Define o tamanho de cada quadrado
    flexGrow: 1,
    flexBasis: 0,
    height: '85px',
    borderRadius: '3px',
    padding: '5px',
    position: 'relative',
    cursor: 'pointer',
    boxShadow: '0 8px 10px #AAA'
  };

  const infoItemDetailStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    height: '100%',
  };

  const infoLabelStyle: CSSProperties = {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '12px',
  };

  const infoValueStyle: CSSProperties = {
    fontSize: '20px',
    fontWeight: 'bold',
  };

  const line1Style: CSSProperties = {
    width: '100%',
    height: '1px',
    backgroundColor: '#ccc',
    margin: '2px 0',
  };

  const line2Style: CSSProperties = {
    position: 'absolute',
    bottom: '-3px',
    left: '0',
    width: '100%',
    height: '5px',
  };

  return (
    <div style={barStyle}>
      <div style={infoContainerStyle}>
        {data?.map((item: any, index: number) => {
          const defaultTextColor =
            item.monitoring_name === "L_TOT_EQUIPMENT_OFF" ||
            (item.monitoring_name === "L_TOT_EQUIPMENT_NO_PREV_BALANCE" &&
              item.is_equipment_balance_above_configured === true)
              ? "#DC3545"
              : item.monitoring_name === "L_TOT_EQUIPMENT_ON"
              ? "#00A403"
              : "var(--bs-primary)";

          const defaultBackground = item.selected ? "#e0e0e0" : "#f0f0f0";

          return (
            <div
              key={index}
              style={{
                ...infoItemStyle,
                backgroundColor: defaultBackground,
                color: defaultTextColor,
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() => clickMonitoring(item.monitoring_name)}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = defaultBackground)}
            >
              <span style={infoItemDetailStyle}>
                <span style={infoValueStyle}>
                  {item.equipment_quantity}
                </span>
                <div style={line1Style}></div>
                <span style={{ ...infoLabelStyle, color: "#6c757d" }}>
                  {t("DASHBOARD." + item.monitoring_name)}
                </span>
              </span>
              <div
                style={{
                  ...line2Style,
                  backgroundColor: defaultTextColor,
                }}
              ></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonitoringBar;